var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5547,
    cy: 24.5098,
    rx: 25,
    ry: 24.5098,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3130_3418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8359 24.4937C20.6359 28.0312 23.5297 30.925 27.0734 32.725L29.8234 29.9688C30.1672 29.625 30.6609 29.525 31.0922 29.6625C32.4922 30.125 33.9984 30.375 35.5547 30.375C36.2484 30.375 36.8047 30.9312 36.8047 31.625V36C36.8047 36.6938 36.2484 37.25 35.5547 37.25C23.8172 37.25 14.3047 27.7375 14.3047 16C14.3047 15.3062 14.8672 14.75 15.5547 14.75H19.9297C20.6234 14.75 21.1797 15.3062 21.1797 16C21.1797 17.5563 21.4297 19.0625 21.8922 20.4625C22.0297 20.8938 21.9297 21.3875 21.5859 21.7312L18.8359 24.4937Z",
    fill: "#7A53FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3130_3418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10.5547 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.0685fafb735389a8de923d4be4d9931f.svg";
export { ForwardRef as ReactComponent };